module.exports = __webpack_public_path__ + "img/tab_gongnue.f548c6e8.png";